import React, { FC } from 'react';
import styled from 'styled-components';
import Icon from '@cld/icon';
import { globalTheme } from '@cld/component-theme';
import { ItemLayoutBaseProps, layoutTypographyMixin, SelectedIcon } from './common';

export type TextItemLayoutProps = ItemLayoutBaseProps;

const Root = styled.div`
  display: flex;
  align-items: center;
  ${layoutTypographyMixin('xs')};
  padding: ${globalTheme.spacing.xs} ${globalTheme.spacing.sm};

  & > ${Icon}:first-child {
    margin-right: ${globalTheme.spacing.xs};
  }
`;

export const TextItemLayout: FC<TextItemLayoutProps> = ({
  children,
  isSelected = false,
  selectionVariant = 'solid',
  showCheckIconWhenSelected = false,
}) => (
  <Root isSelected={isSelected} selectionVariant={selectionVariant} showCheckIconWhenSelected={showCheckIconWhenSelected}>
    {children}
    {isSelected && showCheckIconWhenSelected && <SelectedIcon />}
  </Root>
);
